export default __webpack_public_path__ + "static/media/bgm-003.a1365753.mp3";